import { useQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_AVAILABLE_FILTERS_PATH,
  GetAvailableFiltersErrorDto,
  GetAvailableFiltersRequestQueryParams,
  GetAvailableFiltersSuccessDto,
} from '@/api/rest/resources/types/plot';
import { useWorkstreamId } from '@/pages/shared/home/hooks/useWorkstreamId';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';

type SuccessDto = GetAvailableFiltersSuccessDto;
type ErrorDto = GetAvailableFiltersErrorDto;
type QueryParams = GetAvailableFiltersRequestQueryParams;

export const useAvailableFilters = () => {
  const organizationId = useOrganizationId();
  const workstreamId = useWorkstreamId();

  const queryParams: QueryParams = {
    organization_id: organizationId,
    ...(workstreamId ? { workstream_id: workstreamId } : {}),
  };

  const queryFn = async () => {
    return getRequest<SuccessDto>(GET_AVAILABLE_FILTERS_PATH, undefined, queryParams);
  };

  return useQuery<SuccessDto, ErrorDto>({
    queryKey: ['organization', 'plots', 'available-filters', queryParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
